import { useMemo } from 'react';

import _ from 'lodash';

import { statisticsService } from '../../../services/statistics.service';
import { createApiSlice } from '../utils/createApiSlice';

const getSeasonFieldsStatisticsSlice = createApiSlice({
  reducerPath: ['statistics', 'getSeasonFieldsStatistics'],
  apiFunction: statisticsService.getSeasonFieldsStatistics,
  getStateUpdatePath: (action) => {
    const seasonYear = _.get(action, 'payload.apiArguments.0');
    return [seasonYear];
  },
  getSelectorPath: (seasonYear) => {
    return [seasonYear];
  },
  apiArgumentsFn: ({ seasonYear }) => [seasonYear]
});

const { actions, useApiSelectors } = getSeasonFieldsStatisticsSlice;

export const getSeasonFieldsStatisticsActions = actions;

export const useGetSeasonFieldsStatisticsSelectors = (seasonYear) => {
  const { inProgress, errorMessage, success, response } =
    useApiSelectors(seasonYear);

  return useMemo(
    () => ({
      inProgress,
      errorMessage,
      success,
      response
    }),
    [errorMessage, inProgress, response, success]
  );
};

export default getSeasonFieldsStatisticsSlice;
